<template>
  <div class="slogan-bg">
    <div class="slogan">
      <div class="bg-layer">
        <img :src="require(`../assets/img/home/arrow_${bgNum}.png`)" alt="" />
      </div>
      <p ref="tit" class="tit">
        <!-- <i>{{ this.$t("msg.hello") === "hello" ? enSlogan : zhSlogan }}</i> -->
        <i>{{ this.$t("footer.slogan") }}</i>
      </p>
      <div class="more-btn-container">
        <CoButton
          ref="apply_btn"
          @click.native="$router.push({ path: 'applynow' })"
          arrow
          >{{ $t("btn_list.want_apply") }}</CoButton
        >
        <CoButton
          @click.native="$router.push({ path: 'supportingpartners' })"
          color="green"
          arrow
          >{{ $t("btn_list.want_donor") }}</CoButton
        >
      </div>
    </div>
  </div>
</template>

<script>
import CoButton from "../components/co-button/co-button.vue";
export default {
  data() {
    return {
      bgNum: 1,
      // apply_con: this.$t("btn_list.want_apply"),
      // slogan: this.$t("footer.slogan"),
      zhSlogan: "體育成就未來！",
      enSlogan: "Keep exercising weekly!",
    };
  },
  created() {
    this.timer();
  },
  components: {
    CoButton,
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    timer() {
      return setInterval(() => {
        const oldNum = this.bgNum;
        this.bgNum = (oldNum % 3) + 1;
      }, 300);
    },
    gotoMenu(path) {
      this.$router.push({ path: path });
    },
  },
  // updated() {
  //   // 申请页面改变口号
  //   var lang = localStorage.getItem("locale");
  //   if (localStorage.getItem("selectNav") === 'scholarship') {
  //     if (lang === "en") {
  //       this.enSlogan = 'Keep exercising weekly!';
  //     }else{
  //       this.zhSlogan = '每周運動，保持健康體格！'
  //     }
  //   }else{
  //     if (lang === "en") {
  //       this.enSlogan = 'Keep exercising weekly!';
  //     }else{
  //       this.zhSlogan = '體育成就未來！'
  //     }
  //   }
  // }
};
</script>

<style lang="scss" scoped>
.slogan-bg {
  z-index: 1;
  position: relative;
  background: #fff;
  max-width: 1200px;
  margin: 0 auto;
}
.slogan {
  height: 18vw;
  padding: 3vw 0;

  .bg-layer {
    width: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    img {
      width: 100%;
    }
  }
  .tit {
    font-size: 3vw;
    font-weight: 500;
    color: #2191d0;
    text-align: center;
    position: absolute;
    top: 10vw;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    width: 100%;
  }
  .more-btn-container {
    position: absolute;
    top: 15vw;
    left: 48%;
    transform: translateX(-50%);
    text-align: center;
    width: 60%;
    .more-btn:nth-child(2) {
      margin-left: 1.8vw;
    }
  }
}
@media (max-width: 768px) {
  .slogan-bg {
    z-index: 1;
    position: relative;
    background: #fff;
  }
  .slogan {
    max-width: 1400px;
    height: 30vw;
    margin: 0 auto;
    padding: 3vw 0;
    .bg-layer {
      width: 100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      height: 30vw;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .tit {
      font-size: 4vw;
      font-weight: 600;
      color: #2191d0;
      text-align: center;
      margin: 0;
      position: absolute;
      top: 30%;
      left: 50%;
      transform: translateY(-50%) translateX(-50%);
      width: 100%;
    }
    .more-btn-container {
      position: absolute;
      top: 44%;
      left: 48%;
      transform: translateX(-50%);
      .more-btn {
        margin-top: 1vw;
        font-size: 4vw;
      }
      .more-btn:nth-child(2) {
        margin-left: 0;
      }
    }
  }
}
</style>
